import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import useScrollToSection from '../../../../../hooks/navigation/useScrollToSection';
import IndicativeNumber from '../../../../../../gqlCommon/components/indicativeNumber/IndicativeNumber';

export interface IFeatureCategoryTitleProps {
  name: string;
  code?: string;
  count?: number;
  classes?: {
    title?: string;
    indicativeNumber?: string;
  };
  isSummary?: boolean;
  disclaimerIndicative?: string;
}
const FeatureCategoryTitle: FC<IFeatureCategoryTitleProps> = ({
  name,
  code,
  count,
  classes,
  isSummary,
  disclaimerIndicative,
}) => {
  const { scrollToDisclaimer } = useScrollToSection();

  return (
    <Typography
      component={'h3'}
      className={classes?.title ?? ''}
      data-test={!isSummary ? `accordion:toggle:${name}` : `summary:selected:sectionTitle:${name}`}
    >
      {!count ? name : `${name} (${count})`}
      {disclaimerIndicative && (
        <IndicativeNumber
          dataTest={`${code}`}
          displayNumber={disclaimerIndicative}
          onClick={scrollToDisclaimer}
          className={classes?.indicativeNumber ?? ''}
        />
      )}
    </Typography>
  );
};

export default FeatureCategoryTitle;
